import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Container,
  Box,
  Paper,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Snackbar,
  Alert,
  Chip,
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  CssBaseline,
  useTheme,
  useMediaQuery,
  Avatar,
  Menu,
  Tooltip,
  TextField,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Menu as MenuIcon } from "@mui/icons-material";
import Grocerylogo from "../../images/Grocerylogo.png";
import "@fontsource/poppins"; // Defaults to weight 400
import { Link, useNavigate } from "react-router-dom";

const DeliveryBoyDashboard = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activePage, setActivePage] = useState("dashboard");
  const [orders, setOrders] = useState([]);
  const [filter, setFilter] = useState("All");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();
  const deliveryBoy = JSON.parse(localStorage.getItem("deliveryBoy")); // to access name, etc.
  const deliveryBoyId = localStorage.getItem("deliveryId"); // to pass ID for API
  const [enteredOtps, setEnteredOtps] = useState({});

  // Guard against reaching this dashboard via browser back/forward after logout -
  // client-side routing re-renders this component on popstate without a full
  // reload, so without this check a cleared session would still show cached data.
  useEffect(() => {
    const isLoggedIn = () => !!localStorage.getItem("deliveryId");

    if (!isLoggedIn()) {
      navigate("/MyAccountsSignIn", { replace: true });
      return;
    }

    // Re-check when a bfcache-restored page (e.g. after forward navigation) is shown.
    const handlePageShow = (event) => {
      if (event.persisted && !isLoggedIn()) {
        navigate("/MyAccountsSignIn", { replace: true });
      }
    };
    window.addEventListener("pageshow", handlePageShow);
    return () => window.removeEventListener("pageshow", handlePageShow);
  }, [navigate]);

  useEffect(() => {
    const storedId = localStorage.getItem("deliveryId");
    if (storedId) {
      fetchAssignedOrders(storedId); // ✅ Correct ID pass karo
    } else {
      console.error("DeliveryBoy ID not found in localStorage");
    }
  }, []);

  const fetchAssignedOrders = async (id) => {
    try {
      const res = await axios.get(
        `https://sakhisshop.com/api/orders/deliveryboy/${id}`,
      );
      console.log("Fetched Orders:", res.data); // 👈 Add this
      setOrders(res.data);
    } catch (err) {
      console.error("Failed to fetch orders", err);
    }
  };

  const markAsDelivered = async (orderId) => {
    try {
      await axios.put(`https://sakhisshop.com/api/orders/${orderId}/delivered`);
      setOrders((prev) =>
        prev.map((order) =>
          order.orderId === orderId ? { ...order, status: "Delivered" } : order,
        ),
      );
      setSnackbarOpen(true);
    } catch (err) {
      console.error("Failed to update order status", err);
    }
  };

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const filteredOrders = orders.filter((order) => {
    if (filter === "All") return true;
    if (filter === "Delivered") return order.status === "Delivered";
    if (filter === "Pending") return order.status !== "Delivered";
    return true;
  });

  const handleLogout = () => {
    localStorage.clear();
    navigate("/MyAccountsSignIn", { replace: true });
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handlePageChange = (page) => {
    setActivePage(page);
    if (isMobile) setMobileOpen(false);
  };
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // OTP Verfiy  Functionlity
  const verifyOtpAndMarkDelivered = async (orderId, otp) => {
    try {
      const response = await axios.post(
        `https://sakhisshop.com/api/orders/${orderId}/verify-otp`,
        { otp: otp }, // ✅ Corrected: using the parameter
      );

      alert("OTP Verified and order delivered!");

      setOrders((prevOrders) =>
        prevOrders.map((order) =>
          order.orderId === orderId ? { ...order, status: "Delivered" } : order,
        ),
      );
    } catch (err) {
      console.error(err);
      alert("Invalid OTP or verification failed.");
    }
  };
  const handleOtpChange = (orderId, value) => {
    setEnteredOtps((prev) => ({ ...prev, [orderId]: value }));
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "linear-gradient(to right, #f0f4c3, #e3f2fd)", // Soft blue gradient
        py: 6,
      }}
    >
      <Box sx={{ pb: 8 }}>
        {" "}
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <AppBar
            position="fixed"
            sx={{
              zIndex: (theme) => theme.zIndex.drawer + 1,
              bgcolor: "#1b5e20",
            }}
          >
            <Toolbar sx={{ justifyContent: "space-between", flexWrap: "wrap" }}>
              <IconButton
                color="inherit"
                edge="start"
                onClick={handleDrawerToggle}
                sx={{ display: { sm: "none" } }}
              >
                <MenuIcon />
              </IconButton>

              {/* Logo */}
              <Link to="/">
                <img src={Grocerylogo} alt="Logo" style={{ height: 60 }} />
              </Link>

              {/* Admin Profile with Dropdown */}
              <div>
                <IconButton
                  onClick={handleMenuClick}
                  color="inherit"
                  sx={{ ml: 1 }}
                >
                  <Avatar
                    alt="Admin"
                    // src="/admin-avatar.png" // Use a real profile pic if available
                    sx={{ width: 30, height: 30 }}
                  />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem disabled>
                    <Typography variant="subtitle1">Admin</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </div>
            </Toolbar>
          </AppBar>

          <Container sx={{ mt: { xs: 8, sm: 10 } }}>
            <Paper elevation={3} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
              <Typography variant="h5" gutterBottom>
                Welcome,{" "}
                <strong>
                  {deliveryBoy?.name || deliveryBoy?.username || "Delivery Boy"}
                </strong>{" "}
                👋
              </Typography>
              <Typography variant="body1">
                Manage your assigned orders below.
              </Typography>
            </Paper>

            <FormControl sx={{ mb: 3, minWidth: 200 }}>
              <InputLabel>Filter Orders</InputLabel>
              <Select
                value={filter}
                label="Filter Orders"
                onChange={(e) => setFilter(e.target.value)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Pending">Pending</MenuItem>
                <MenuItem value="Delivered">Delivered</MenuItem>
              </Select>
            </FormControl>

            {filteredOrders.length === 0 ? (
              <Typography>No orders available for this filter.</Typography>
            ) : (
              filteredOrders.map((order) => {
                const isDelivered = order.status === "Delivered";
                return (
                  <Paper
                    key={order.id}
                    elevation={2}
                    sx={{
                      mb: 3,
                      p: 2,
                      backgroundColor: isDelivered ? "#e0f7e9" : "white",
                      borderLeft: isDelivered
                        ? "6px solid green"
                        : "4px solid #1976d2",
                    }}
                  >
                    <Typography variant="h6">
                      <strong>Order ID:</strong> {order.orderId}
                    </Typography>
                    <Typography>
                      <strong>Customer:</strong> {order.customerName}
                    </Typography>
                    <Typography>
                      <strong>Address:</strong> {order.address}
                    </Typography>
                    <Typography sx={{ mt: 1 }}>
                      <strong>Status:</strong>{" "}
                      {isDelivered ? (
                        <Chip label="Delivered" color="success" size="small" />
                      ) : (
                        <Chip
                          label={order.status}
                          color="warning"
                          size="small"
                        />
                      )}
                    </Typography>

                    <Divider sx={{ my: 2 }} />
                    <Typography variant="subtitle1" gutterBottom>
                      🛒 Order Items:
                    </Typography>
                    <List dense>
                      {order.orderItems?.map((item, idx) => (
                        <ListItem key={idx}>
                          <ListItemText
                            primary={`${item.productName} (Qty: ${item.quantity})`}
                            secondary={`Price: ₹${item.mrp}`}
                          />
                        </ListItem>
                      ))}
                    </List>

                    <Tooltip
                      title={
                        isDelivered
                          ? "Already delivered"
                          : order.paymentMethod === "Online" &&
                              order.paymentStatus !== "Paid"
                            ? "Payment not completed"
                            : "Mark as Delivered"
                      }
                    >
                      {/* Verfiy OTP logic for Putting OTP and Sttus Change Delivered */}
                      {/* <Box>
  <TextField
  label="Enter OTP"
  value={enteredOtps[order.orderId] || ""}
  onChange={(e) => handleOtpChange(order.orderId, e.target.value)}
  sx={{ mt: 2, mr: 2 }}
/>
<Button onClick={() => verifyOtpAndMarkDelivered(order.orderId, enteredOtps[order.orderId])}>
  Verify OTP & Deliver
</Button>
 </Box> */}

                      <Box>
                        <TextField
                          label="Enter OTP"
                          value={enteredOtps[order.orderId] || ""}
                          onChange={(e) =>
                            handleOtpChange(order.orderId, e.target.value)
                          }
                          sx={{ mt: 2, mr: 2 }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={!enteredOtps[order.orderId]} // 🔒 Disable until OTP entered
                          onClick={() =>
                            verifyOtpAndMarkDelivered(
                              order.orderId,
                              enteredOtps[order.orderId],
                            )
                          }
                        >
                          Verify OTP & Deliver
                        </Button>
                      </Box>
                      <span>
                        <Button
                          variant="contained"
                          color="success"
                          onClick={() => markAsDelivered(order.orderId)}
                          disabled={
                            isDelivered ||
                            !enteredOtps[order.orderId] || // ✅ Disable until OTP entered
                            (order.paymentMethod === "Online" &&
                              order.paymentStatus !== "Paid")
                          }
                          sx={{ mt: 2 }}
                        >
                          {isDelivered
                            ? "✅ Delivered"
                            : "✅ Mark as Delivered"}
                        </Button>
                      </span>
                    </Tooltip>
                  </Paper>
                );
              })
            )}

            <Snackbar
              open={snackbarOpen}
              autoHideDuration={3000}
              onClose={handleSnackbarClose}
              anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            >
              <Alert
                onClose={handleSnackbarClose}
                severity="success"
                sx={{ width: "100%" }}
              >
                Order marked as delivered successfully!
              </Alert>
            </Snackbar>
          </Container>
        </ThemeProvider>
      </Box>
    </Box>
  );
};

export default DeliveryBoyDashboard;
